<template>
  <div class="isis-selections-box">
    <div class="title">{{ title }}</div>
    <div class="custom-select" :tabindex="tabindex" @blur="open = false">
      <div class="selected" :class="{ open: open }" @click="open = !open">
        {{ selected }}
      </div>
      <div class="items" :class="{ selectHide: !open }">
        <div
          v-for="(option, i) of options"
          :key="i"
          @click="
            selected = option;
            open = false;
            $emit('input', option);
          "
        >
          {{ option }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    default: {
      type: [String, Number],
      required: false,
      default: () => null
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options.length > 0
        ? this.options[0]
        : null,
      open: false
    };
  },
  created() {
    this.$emit("input", this.selected);
  }
};
</script>

<style scoped lang="scss">
$text-color: #3c4858;
$bg-color: #dcdcdc;

.isis-selections-box {
  min-width: 157px;
  display: flex;
  justify-content: center;
  align-items: center;

  .title {
    margin: 0;
    margin-right: 10px;
    font-size: 12px;
    color: #999999;
  }
}

.custom-select {
  position: relative;
  text-align: left;
  outline: none;

  .selected {
    padding-left: 15px;
    padding-right: 30px;

    background-color: $bg-color;
    border-radius: 42px;

    color: $text-color;
    font-size: 14px;
    font-weight: 500;

    cursor: pointer;
    user-select: none;

    transition: 0.2s;
    line-height: 24px;

    &:hover {
      background-color: darken($bg-color, 10%);
    }
  }
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #1b1f22 transparent transparent transparent;

  transform: translateY(-19%);
}

.custom-select .items {
  border-radius: 6px;
  overflow: hidden;

  position: absolute;
  background-color: $bg-color;
  top: 110%;
  left: 0;
  right: 0;
  z-index: 99;
}

.custom-select .items div {
  color: $text-color;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;

  font-weight: 400;

  transition: 0.2s;
}

.custom-select .items div:hover {
  background-color: darken($bg-color, 10%);
}

.selectHide {
  display: none;
}
</style>
